import { useTranslations } from "next-intl";

const useMigelConformity = (migelConformity) => {
  const t = useTranslations();

  switch (migelConformity) {
    case "CONFORMANT":
      return ["migel-ok", t("article-migel"), t("article-migel-tooltip")];
    case "NON_CONFORMANT":
      return [
        "migel-nok",
        t("article-not-migel"),
        t("article-not-migel-tooltip"),
      ];
    case "DEFAULT":
      return ["info", t("migel-conformity"), t("can_include_costs_detailed")];
    default:
      return [null, null, null];
  }
};

export default useMigelConformity;
